import { render, staticRenderFns } from "./MNewsDetail.vue?vue&type=template&id=7c5d5b22&"
import script from "./MNewsDetail.vue?vue&type=script&lang=js&"
export * from "./MNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports